import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  InputField,
  Typography,
} from "fds";
import "./index.scss";
import dayjs from "dayjs";
import { FilterData } from "../../types/adminFilter";
import classNames from "classnames";
import { t } from "i18next";
import { CommonProps } from "@front/fds2.0-green/dist/src/helpers/props";
import { Member, Workgroup } from "../../types/workgroup";
import DateDropdown from "../DateDropdown";
import utilsCommon from "../../shared/utils/common";
import {
  getAdminInfoFromLocalStorage,
  getUserInfoFromLocalStorage,
  getWorkspaceCode,
} from "../../shared/utils/auth";
import useWorkspaceStore from "../../redux/dispatcher/useWorkspaceStore";
import useAdminDeptStore from "../../redux/dispatcher/useAdminDeptStore";
import WorkgroupCheckboxDropdown from "../WorkgroupCheckboxDropdown";
import { LoginDto } from "../../types/auth";
import UserSearchDropdown from "../UserSearchDropdown";
import isEqual from "lodash/isEqual";
import omit from "lodash/omit";
import useCheckboxGroup from "../../shared/hooks/useCheckboxGroup";
import AdminUserSearchDropdown from "../UserSearchDropdown/AdminUserSearchDropdown";
import { UserDTO } from "../../types/adminDept";

interface AdminFilterProps extends CommonProps {
  initFilterData: FilterData;
  filterData: FilterData;
  setFilterData: any;
  search?: any;
  workgroupList?: Workgroup[];
  initNum?: number;
  page?: string;
}
const AdminFilter: React.FC<AdminFilterProps> = ({
  initFilterData,
  filterData,
  setFilterData,
  search,
  initNum,
  workgroupList,
  classes,
  page,
}) => {
  const { searchUserList } = useAdminDeptStore();
  const { getWorkspaceMemberList } = useWorkspaceStore();
  const [buttonClick, setButtonClick] = useState(0);
  const [userId, setUserId] = useState<string>("");
  const [workgroupId, setWorkgroupId] = useState<string>("");
  const [userType, setUserType] = useState<string>("user_all");
  const [accessType, setAccessType] = useState<string>("");
  const [agentType, setAgentType] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [fileManager, setFileManager] = useState<string>("");
  const [workgroupMaster, setWorkgroupMaster] = useState<string>("");
  const [workgroupName, setWorkgroupName] = useState<string>("");
  const [member, setMember] = useState<string>("");
  const filterWorkgroups = useCheckboxGroup<number>([]);
  const filterDocuments = useCheckboxGroup<number>([]);

  const user = window.location.href.includes("/admin")
    ? (getAdminInfoFromLocalStorage() as string)
    : (getUserInfoFromLocalStorage() as string | "");
  const loginDto: LoginDto = JSON.parse(user);
  const userTypes = [
    { key: "user_all", label: t("admin.filter.userAll") },
    { key: "user_admin", label: t("admin.filter.userAdmin") },
    { key: "user_internal", label: t("admin.filter.userInternal") },
    { key: "user_external", label: t("admin.filter.userExternal") },
    { key: "user_select", label: t("admin.filter.userSelect") },
  ];

  const accessTypes = [
    { key: "", label: t("admin.filter.accessPlace") },
    { key: "ADMIN", label: t("admin.filter.adminArea") },
    { key: "USER", label: t("admin.filter.userArea") },
    { key: "URL", label: t("admin.filter.urlArea") },
  ];

  const agentTypes = [
    { key: "", label: t("admin.filter.platformAll") },
    { key: "WEB", label: t("admin.filter.webBrowser") },
    { key: "CLIENT", label: t("admin.filter.wrapsodyEcoClient") },
    { key: "MOBILE", label: t("admin.filter.mobileApp") },
  ];

  const filterWorkgroup = [
    { key: 0, label: t("log.filterWorkgroup.0") },
    { key: 1, label: t("log.filterWorkgroup.1") },
    { key: 2, label: t("log.filterWorkgroup.2") },
    { key: 3, label: t("log.filterWorkgroup.3") },
    { key: 4, label: t("log.filterWorkgroup.4") },
  ];

  const filterDocument = [
    { key: 0, label: t("log.filterDocument.0") },
    { key: 1, label: t("log.filterDocument.1") },
    { key: 2, label: t("log.filterDocument.2") },
    { key: 3, label: t("log.filterDocument.3") },
    { key: 4, label: t("log.filterDocument.4") },
    { key: 5, label: t("log.filterDocument.5") },
    { key: 6, label: t("log.filterDocument.6") },
    { key: 7, label: t("log.filterDocument.7") },
    { key: 8, label: t("log.filterDocument.8") },
    { key: 9, label: t("log.filterDocument.9") },
    { key: 10, label: t("log.filterDocument.10") },
    { key: 11, label: t("log.filterDocument.11") },
  ];
  const [users, changeUsers] = useState<Member[]>([]);
  const [savedUsers, changeSavedUsers] = useState<Member[]>([]);
  const [adminUsers, changeAdminUsers] = useState<UserDTO[]>([]);
  const [adminSavedUsers, changeAdminSavedUsers] = useState<UserDTO[]>([]);

  useEffect(() => {
    setFilterData(initFilterData);
    setFileName("");
    setFileManager("");
    setWorkgroupMaster("");
    setWorkgroupName("");
    setUserId("");
    setMember("");
    setAgentType("");
    setAccessType("");
    setUserType("user_all");
    changeUsers([]);
    changeSavedUsers([]);
    changeAdminUsers([]);
    changeAdminSavedUsers([]);
  }, [initNum]);
  return (
    <Box classes={classNames("adminFilter", classes)}>
      <Button
        onClick={() => {
          setFilterData(initFilterData);
          setFileName("");
          setFileManager("");
          setWorkgroupMaster("");
          setWorkgroupName("");
          setUserId("");
          setMember("");
          setAgentType("");
          setAccessType("");
          setUserType("user_all");
          filterWorkgroups.handleAllClick([]);
          filterDocuments.handleAllClick([]);
          changeUsers([]);
          changeSavedUsers([]);
          changeAdminUsers([]);
          changeAdminSavedUsers([]);
        }}
        btnStyle="icon"
        size="sm"
        state={
          isEqual(
            omit(initFilterData, ["order", "orderType"]),
            omit(filterData, ["order", "orderType"])
          )
            ? "disable"
            : "default"
        }
        leadingIcon={<Icons variant="line" label="redoLeft" size={16} />}
      />
      {filterData.workgroupName !== undefined && (
        <Dropdown
          btnStyle="round"
          btnSize="rd"
          buttonWidth={320}
          placeholder={t("admin.filter.workgroup")}
          value={
            filterData.workgroupName === ""
              ? undefined
              : filterData.workgroupName + ""
          }
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box classes="adminFilter-user" direction="column">
            <Box classes="adminFilter-user-title">
              {t("admin.filter.workgroup")}
            </Box>
            <InputField
              classes="adminFilter-user-search"
              leadingIcon={<Icons label="search" variant="line" />}
              placeholder={t("admin.filter.inputSearch")}
              value={workgroupName}
              onChange={(e) => setWorkgroupName(e.target.value)}
              onKeyUp={(e: any) => {
                if (e.code === "Enter") {
                  setFilterData({
                    ...filterData,
                    workgroupName: workgroupName,
                  });
                  setButtonClick(buttonClick + 1);
                }
              }}
            />
            <Box classes="adminFilter-user-footer">
              <Button
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                type="secondary"
                onClick={() => {
                  setWorkgroupName("");
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                btnStyle="fill"
                label={t("admin.common.button.apply")}
                onClick={() => {
                  setFilterData({
                    ...filterData,
                    workgroupName: workgroupName,
                  });
                  setButtonClick(buttonClick + 1);
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.workgroupMaster !== undefined && (
        <Dropdown
          btnStyle="round"
          btnSize="rd"
          buttonWidth={320}
          placeholder={t("admin.filter.workgroupManager")}
          value={
            filterData.workgroupMaster === ""
              ? undefined
              : filterData.workgroupMaster + ""
          }
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box classes="adminFilter-user" direction="column">
            <Box classes="adminFilter-user-title">
              {t("admin.filter.workgroupManager")}
            </Box>
            <InputField
              classes="adminFilter-user-search"
              leadingIcon={<Icons label="search" variant="line" />}
              placeholder={t("admin.filter.inputSearch")}
              value={workgroupMaster}
              onChange={(e) => {
                setWorkgroupMaster(e.target.value);
              }}
              onKeyUp={async (e: any) => {
                if (e.code === "Enter") {
                  let resp: any = await (window.eco.serviceType !== "OCI"
                    ? searchUserList(workgroupMaster)
                    : getWorkspaceMemberList({
                        searchOpt: workgroupMaster,
                        userType: null,
                        isAdminPage: true,
                        order: "user",
                        dsdCode: getWorkspaceCode() ?? "",
                        tenancyCode: getWorkspaceCode() ?? "",
                      }));
                  if (resp.payload) {
                    setFilterData({
                      ...filterData,
                      workgroupMaster:
                        window.eco.serviceType !== "OCI" ||
                        resp.payload?.users[0]?.id
                          ? resp.payload?.users[0]?.id ?? ""
                          : resp.payload[0]?.userId ?? "",
                    });
                    setButtonClick(buttonClick + 1);
                  }
                }
              }}
            />
            <Box classes="adminFilter-user-footer">
              <Button
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                type="secondary"
                onClick={() => {
                  setWorkgroupMaster("");
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                btnStyle="fill"
                label={t("admin.common.button.apply")}
                onClick={async () => {
                  if (workgroupMaster === "") {
                    setFilterData({
                      ...filterData,
                      workgroupMaster: "",
                    });
                    setButtonClick(buttonClick + 1);
                    return;
                  }
                  let resp: any = await (window.eco.serviceType !== "OCI"
                    ? searchUserList(workgroupMaster)
                    : getWorkspaceMemberList({
                        searchOpt: workgroupMaster,
                        userType: null,
                        isAdminPage: true,
                        order: "user",
                        dsdCode: getWorkspaceCode() ?? "",
                        tenancyCode: getWorkspaceCode() ?? "",
                      }));
                  if (resp.payload) {
                    setFilterData({
                      ...filterData,
                      workgroupMaster:
                        window.eco.serviceType !== "OCI" ||
                        resp.payload?.users[0]?.id
                          ? resp.payload?.users[0]?.id ?? ""
                          : resp.payload[0]?.userId ?? "",
                    });
                    setButtonClick(buttonClick + 1);
                  }
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.member !== undefined && (
        <Dropdown
          btnStyle="round"
          btnSize="rd"
          buttonWidth={320}
          placeholder={t("admin.filter.member")}
          value={filterData.member === "" ? undefined : filterData.member + ""}
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box classes="adminFilter-user" direction="column">
            <Box classes="adminFilter-user-title">
              {t("admin.filter.member")}
            </Box>
            <InputField
              classes="adminFilter-user-search"
              leadingIcon={<Icons label="search" variant="line" />}
              placeholder={t("admin.filter.inputSearch")}
              value={member}
              onChange={(e) => {
                setMember(e.target.value);
              }}
              onKeyUp={async (e: any) => {
                if (e.code === "Enter") {
                  let resp: any = await (window.eco.serviceType !== "OCI"
                    ? searchUserList(member)
                    : getWorkspaceMemberList({
                        searchOpt: member,
                        userType: null,
                        isAdminPage: true,
                        order: "user",
                        dsdCode: getWorkspaceCode() ?? "",
                        tenancyCode: getWorkspaceCode() ?? "",
                      }));
                  if (resp.payload) {
                    setFilterData({
                      ...filterData,
                      member:
                        window.eco.serviceType !== "OCI" ||
                        resp.payload?.users[0]?.id
                          ? resp.payload?.users[0]?.id ?? ""
                          : resp.payload[0]?.userId ?? "",
                    });
                    setButtonClick(buttonClick + 1);
                  }
                }
              }}
            />
            <Box classes="adminFilter-user-footer">
              <Button
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                type="secondary"
                onClick={() => {
                  setMember("");
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                btnStyle="fill"
                label={t("admin.common.button.apply")}
                onClick={async () => {
                  let resp: any = await (window.eco.serviceType !== "OCI"
                    ? searchUserList(member)
                    : getWorkspaceMemberList({
                        searchOpt: member,
                        userType: null,
                        isAdminPage: true,
                        order: "user",
                        dsdCode: getWorkspaceCode() ?? "",
                        tenancyCode: getWorkspaceCode() ?? "",
                      }));
                  if (resp.payload) {
                    setFilterData({
                      ...filterData,
                      member:
                        window.eco.serviceType !== "OCI" ||
                        resp.payload?.users[0]?.id
                          ? resp.payload?.users[0]?.id ?? ""
                          : resp.payload[0]?.userId ?? "",
                    });
                    setButtonClick(buttonClick + 1);
                  }
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.userId !== undefined &&
        filterData.userType === undefined &&
        !window.location.href.includes("/admin") && (
          <UserSearchDropdown
            buttonClick={buttonClick}
            filter={filterData}
            users={users}
            pageFrom="workgroupLog"
            savedUsers={savedUsers}
            isAllowEmptyUser
            isSingle
            title={t("admin.filter.user")}
            buttonTitle={t("admin.filter.user")}
            changeUsers={changeUsers}
            changeFilterByKey={(temp, tempVals) => {
              const foundUser = users.filter(
                (item) => item.userId === tempVals[0]
              );
              setFilterData({
                ...filterData,
                userId: tempVals[0] ?? "",
              });
              changeUsers(foundUser ?? []);
              changeSavedUsers(foundUser ?? []);
            }}
            setButtonClick={setButtonClick}
          />
        )}
      {filterData.userId !== undefined &&
        filterData.userType === undefined &&
        window.location.href.includes("/admin") && (
          <AdminUserSearchDropdown
            buttonClick={buttonClick}
            filter={filterData}
            pageFrom="workgroupLog"
            users={adminUsers}
            savedUsers={adminSavedUsers}
            title={t("admin.filter.user")}
            buttonTitle={t("admin.filter.user")}
            isAllowEmptyUser
            isSingle
            changeUsers={changeAdminUsers}
            changeFilterByKey={(temp, tempVals) => {
              const foundUser = adminUsers.filter(
                (item) => item.id === tempVals[0]
              );
              setFilterData({
                ...filterData,
                userId: tempVals[0] ?? "",
              });
              changeAdminUsers(foundUser ?? []);
              changeAdminSavedUsers(foundUser ?? []);
            }}
            setButtonClick={setButtonClick}
          />
        )}

      {/* {filterData.userId !== undefined &&
        filterData.userType === undefined &&
        window.location.href.includes("/admin") && (
          <Dropdown
            btnStyle="round"
            btnSize="rd"
            buttonWidth={320}
            placeholder={t("admin.filter.user")}
            value={
              filterData.userId === "" ? undefined : filterData.userId + ""
            }
            showValue={true}
            buttonClick={buttonClick}
            classes="mg ml-12"
          >
            <Box classes="adminFilter-user" direction="column">
              <Box classes="adminFilter-user-title">
                {t("admin.filter.user")}
              </Box>
              <InputField
                classes="adminFilter-user-search"
                leadingIcon={<Icons label="search" variant="line" />}
                placeholder={t("admin.filter.inputUserId")}
                value={userId}
                onChange={(e) => {
                  setUserId(e.target.value);
                }}
                onKeyUp={async (e: any) => {
                  if (e.code === "Enter") {
                    let resp: any = await (window.eco.serviceType !== "OCI"
                      ? searchUserList(userId)
                      : getWorkspaceMemberList({
                          searchOpt: userId,
                          userType: null,
                          isAdminPage: true,
                          order: "user",
                          dsdCode: getWorkspaceCode() ?? "",
                          tenancyCode: getWorkspaceCode() ?? "",
                        }));
                    if (resp.payload) {
                      setFilterData({
                        ...filterData,
                        userId:
                          window.eco.serviceType !== "OCI"
                            ? resp.payload?.users[0]?.id ?? ""
                            : resp.payload[0]?.userId ?? "",
                      });
                      setButtonClick(buttonClick + 1);
                    }
                  }
                }}
              />
              <Box classes="adminFilter-user-footer">
                <Button
                  btnStyle="fill"
                  label={t("admin.common.button.cancel")}
                  type="secondary"
                  onClick={() => {
                    setUserId("");
                    setButtonClick(buttonClick + 1);
                  }}
                />
                <Button
                  btnStyle="fill"
                  label={t("admin.common.button.apply")}
                  onClick={async () => {
                    let resp: any = await (window.eco.serviceType !== "OCI"
                      ? searchUserList(userId)
                      : getWorkspaceMemberList({
                          searchOpt: userId,
                          userType: null,
                          isAdminPage: true,
                          order: "user",
                          dsdCode: getWorkspaceCode() ?? "",
                          tenancyCode: getWorkspaceCode() ?? "",
                        }));
                    if (resp.payload) {
                      setFilterData({
                        ...filterData,
                        userId:
                          window.eco.serviceType !== "OCI"
                            ? resp.payload?.users[0]?.id ?? ""
                            : resp.payload[0]?.userId ?? "",
                      });
                      setButtonClick(buttonClick + 1);
                    }
                  }}
                />
              </Box>
            </Box>
          </Dropdown>
        )} */}
      {filterData.userId !== undefined && filterData.userType !== undefined && (
        <Dropdown
          btnStyle="round"
          btnSize="rd"
          buttonWidth={320}
          placeholder={t("admin.filter.user")}
          value={
            filterData.userType === "user_all"
              ? undefined
              : userTypes.find((item) => item.key === filterData.userType)
                  ?.label
          }
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box classes="adminFilter-user" direction="column">
            {userTypes.map((item) => (
              <DropdownItem
                type="check"
                label={item.label}
                checked={userType === item.key}
                checkColor={userType === item.key}
                onClick={() => {
                  setUserType(item.key);
                }}
              />
            ))}
            {userType === "user_select" && (
              <>
                <DropdownItem type="default" state="divider" />
                <InputField
                  classes="adminFilter-user-search"
                  leadingIcon={<Icons label="search" variant="line" />}
                  placeholder={t("admin.filter.inputUserId")}
                  value={userId}
                  onChange={(e) => {
                    setUserId(e.target.value);
                  }}
                  onKeyUp={async (e: any) => {
                    if (e.code === "Enter") {
                      setFilterData({
                        ...filterData,
                        userId: userType === "user_select" ? userId : "",
                        userType: userType,
                      });
                      if (userType !== "user_select") {
                        setUserId("");
                      }
                      setButtonClick(buttonClick + 1);
                    }
                  }}
                />
              </>
            )}
            <Box classes="adminFilter-user-footer">
              <Button
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                type="secondary"
                onClick={() => {
                  setUserId(filterData.userId + "");
                  setUserType(filterData.userType + "");
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                btnStyle="fill"
                label={t("admin.common.button.apply")}
                onClick={() => {
                  setFilterData({
                    ...filterData,
                    userId: userType === "user_select" ? userId : "",
                    userType: userType,
                  });
                  if (userType !== "user_select") {
                    setUserId("");
                  }
                  setButtonClick(buttonClick + 1);
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.accessType !== undefined && (
        <Dropdown
          btnStyle="round"
          btnSize="rd"
          buttonWidth={240}
          placeholder={t("admin.log.accessPlace")}
          value={
            filterData.accessType === ""
              ? undefined
              : accessTypes.find((item) => item.key === filterData.accessType)
                  ?.label
          }
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box classes="adminFilter-user" direction="column">
            {accessTypes.map((item) => (
              <DropdownItem
                type="check"
                label={item.label}
                checked={accessType === item.key}
                checkColor={accessType === item.key}
                onClick={() => {
                  setAccessType(item.key);
                }}
              />
            ))}
            <Box classes="adminFilter-user-footer">
              <Button
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                type="secondary"
                onClick={() => {
                  setAccessType(filterData.accessType + "");
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                btnStyle="fill"
                label={t("admin.common.button.apply")}
                onClick={() => {
                  setFilterData({
                    ...filterData,
                    accessType: accessType,
                  });
                  setButtonClick(buttonClick + 1);
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.agentType !== undefined && (
        <Dropdown
          btnStyle="round"
          btnSize="rd"
          buttonWidth={240}
          placeholder={t("admin.log.platform")}
          value={
            filterData.agentType === ""
              ? undefined
              : agentTypes.find((item) => item.key === filterData.agentType)
                  ?.label
          }
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box classes="adminFilter-user" direction="column">
            {agentTypes.map((item) => (
              <DropdownItem
                type="check"
                label={item.label}
                checked={agentType === item.key}
                checkColor={agentType === item.key}
                onClick={() => {
                  setAgentType(item.key);
                }}
              />
            ))}
            <Box classes="adminFilter-user-footer">
              <Button
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                type="secondary"
                onClick={() => {
                  setAgentType(filterData.agentType + "");
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                btnStyle="fill"
                label={t("admin.common.button.apply")}
                onClick={() => {
                  setFilterData({
                    ...filterData,
                    agentType: agentType,
                  });
                  setButtonClick(buttonClick + 1);
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.fileName !== undefined && (
        <Dropdown
          btnStyle="round"
          btnSize="rd"
          buttonWidth={320}
          placeholder={t("admin.filter.fileName")}
          value={
            filterData.fileName === "" ? undefined : filterData.fileName + ""
          }
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box classes="adminFilter-user" direction="column">
            <Box classes="adminFilter-user-title">
              {t("admin.filter.fileName")}
            </Box>
            <InputField
              classes="adminFilter-user-search"
              leadingIcon={<Icons label="search" variant="line" />}
              placeholder={t("admin.filter.inputFileName")}
              value={fileName}
              onChange={(e) => {
                setFileName(e.target.value);
              }}
              onKeyUp={async (e: any) => {
                if (e.code === "Enter") {
                  setFilterData({
                    ...filterData,
                    fileName: fileName,
                  });
                  setButtonClick(buttonClick + 1);
                }
              }}
            />
            <Box classes="adminFilter-user-footer">
              <Button
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                type="secondary"
                onClick={() => {
                  setFileName("");
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                btnStyle="fill"
                label={t("admin.common.button.apply")}
                onClick={() => {
                  setFilterData({
                    ...filterData,
                    fileName: fileName,
                  });
                  setButtonClick(buttonClick + 1);
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.fileManager !== undefined && (
        <Dropdown
          btnStyle="round"
          btnSize="rd"
          buttonWidth={320}
          placeholder={t("admin.filter.fileManager")}
          value={
            filterData.fileManager === ""
              ? undefined
              : filterData.fileManager + ""
          }
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box classes="adminFilter-user" direction="column">
            <Box classes="adminFilter-user-title">
              {t("admin.filter.fileManager")}
            </Box>
            <InputField
              classes="adminFilter-user-search"
              leadingIcon={<Icons label="search" variant="line" />}
              placeholder={t("admin.filter.inputSearch")}
              value={fileManager}
              onChange={(e) => {
                setFileManager(e.target.value);
              }}
              onKeyUp={async (e: any) => {
                if (e.code === "Enter") {
                  setFilterData({
                    ...filterData,
                    fileManager: fileManager,
                  });
                  setButtonClick(buttonClick + 1);
                }
              }}
            />
            <Box classes="adminFilter-user-footer">
              <Button
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                type="secondary"
                onClick={() => {
                  setFileManager("");
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                btnStyle="fill"
                label={t("admin.common.button.apply")}
                onClick={() => {
                  setFilterData({
                    ...filterData,
                    fileManager: fileManager,
                  });
                  setButtonClick(buttonClick + 1);
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.saveTypes !== undefined && (
        <Dropdown
          btnStyle="round"
          placeholder={t("admin.filter.type")}
          buttonWidth={290}
          value={
            filterData.saveTypes.length === 0
              ? undefined
              : filterData.saveTypes.length + ""
          }
          showValue={true}
          buttonClick={buttonClick}
          classes="mg ml-12"
        >
          <Box width={274} maxHeight={388} classes={"fav-checkbox"}>
            <Box
              height={26}
              width="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                type="caption1_rg"
                classes="mg ml-8"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.filter.type")}
              </Typography>
              <Button
                btnStyle="link"
                label={
                  filterDocuments.selected.length === filterDocument.length
                    ? t("admin.filter.unselectAll")
                    : t("admin.filter.selectAll")
                }
                onClick={() =>
                  filterDocuments.selected.length === filterDocument.length
                    ? filterDocuments.handleAllClick([])
                    : filterDocuments.handleAllClick(
                        filterDocument.map((item) => item.key)
                      )
                }
                textColor={getColor("COLOR_TEXT_BRAND")}
              />
            </Box>
            <Box classes="mg mt-4 fav-workgroups">
              {filterDocument.map((item) => (
                <Checkbox
                  label={item.label}
                  onClick={() => filterDocuments.handleClick(item.key)}
                  check={filterDocuments.isSelected(item.key)}
                />
              ))}
            </Box>
            <Box classes="fav-checkbox--bottom">
              <Button
                label={t("admin.common.button.cancel")}
                type="secondary"
                btnStyle="fill"
                onClick={() => {
                  filterData.saveTypes &&
                    filterDocuments.handleAllClick(filterData.saveTypes);
                  setButtonClick(buttonClick + 1);
                }}
              />
              <Button
                label={t("admin.common.button.apply")}
                classes="mg ml-10"
                btnStyle="fill"
                onClick={() => {
                  setFilterData({
                    ...filterData,
                    saveTypes: filterDocuments.selected,
                  });
                  setButtonClick(buttonClick + 1);
                }}
              />
            </Box>
          </Box>
        </Dropdown>
      )}
      {filterData.filterWorkgroup !== undefined &&
        filterData.filterDocument !== undefined && (
          <Dropdown
            btnStyle="round"
            placeholder={t("admin.filter.type")}
            buttonWidth={290}
            value={
              filterData.filterWorkgroup.length +
                filterData.filterDocument.length ===
              0
                ? undefined
                : filterData.filterWorkgroup.length +
                  filterData.filterDocument.length +
                  ""
            }
            showValue={true}
            buttonClick={buttonClick}
            classes="mg ml-12"
          >
            <Box width={274} maxHeight={388} classes={"fav-checkbox"}>
              <Box
                height={26}
                width="100%"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  type="caption1_rg"
                  classes="mg ml-8"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.filter.type")}
                </Typography>
                <Button
                  btnStyle="link"
                  label={
                    filterWorkgroups.selected.length === filterWorkgroup.length
                      ? t("admin.filter.unselectAll")
                      : t("admin.filter.selectAll")
                  }
                  onClick={() =>
                    filterWorkgroups.selected.length === filterWorkgroup.length
                      ? filterWorkgroups.handleAllClick([])
                      : filterWorkgroups.handleAllClick(
                          filterWorkgroup?.map((item) => item.key)
                        )
                  }
                  textColor={getColor("COLOR_TEXT_BRAND")}
                />
              </Box>
              <Box classes="mg mt-4 fav-workgroups">
                {filterWorkgroup.map((item) => (
                  <Checkbox
                    label={item.label}
                    onClick={() => filterWorkgroups.handleClick(item.key)}
                    check={
                      filterWorkgroups.isSelected(item.key) &&
                      filterWorkgroups.selected.length > 0
                    }
                  />
                ))}
              </Box>
              <Box classes="fav-checkbox--bottom">
                <Button
                  label={t("admin.common.button.cancel")}
                  type="secondary"
                  btnStyle="fill"
                  onClick={() => {
                    if (
                      filterData.filterWorkgroup &&
                      filterData.filterDocument
                    ) {
                      let tempIds = [] as number[];

                      filterData.filterWorkgroup.map((item) =>
                        tempIds.push(item)
                      );
                      filterData.filterDocument.map((item) =>
                        tempIds.push(item + 100)
                      );
                      filterWorkgroups.handleAllClick(tempIds);
                    }
                    setButtonClick(buttonClick + 1);
                  }}
                />
                <Button
                  label={t("admin.common.button.apply")}
                  classes="mg ml-10"
                  btnStyle="fill"
                  onClick={() => {
                    setFilterData({
                      ...filterData,
                      filterWorkgroup: filterWorkgroups.selected
                        .filter((item: number) => item < 100)
                        .map((item: number) => item),
                      filterDocument: filterWorkgroups.selected
                        .filter((item: number) => item > 100)
                        .map((item: number) => Number(item - 100)),
                    });
                    setButtonClick(buttonClick + 1);
                  }}
                />
              </Box>
            </Box>
          </Dropdown>
        )}
      {filterData.workgroupIds === undefined &&
        filterData.workgroupId !== undefined &&
        loginDto?.ecoSystemLicenseStats.featureAccessType !== "LITE" &&
        workgroupList && (
          <Dropdown
            btnStyle="round"
            placeholder={t("admin.filter.workgroup")}
            buttonWidth={290}
            value={
              filterData.workgroupId === ""
                ? undefined
                : filterData.workgroupId === "NONEWORKGROUP"
                ? "My Box"
                : workgroupList.filter(
                    (item: Workgroup) =>
                      item.workgroupId === filterData.workgroupId
                  ).length > 0
                ? workgroupList.filter(
                    (item: Workgroup) =>
                      item.workgroupId === filterData.workgroupId
                  )[0].workgroupName
                : undefined
            }
            showValue={true}
            buttonClick={buttonClick}
            classes="mg ml-12"
          >
            <Box width={274} maxHeight={388} classes={"fav-checkbox"}>
              <Box classes="mg mt-4 fav-workgroups">
                <DropdownItem
                  type="check"
                  label={t("admin.filter.workgroupAll")}
                  checked={workgroupId === ""}
                  checkColor={workgroupId === ""}
                  onClick={() => {
                    setWorkgroupId("");
                  }}
                />
                <DropdownItem
                  type="check"
                  label={"My Box"}
                  checked={workgroupId === "NONEWORKGROUP"}
                  checkColor={workgroupId === "NONEWORKGROUP"}
                  onClick={() => {
                    setWorkgroupId("NONEWORKGROUP");
                  }}
                />
                {workgroupList.map((workgroup) => (
                  <DropdownItem
                    type="check"
                    label={workgroup.workgroupName}
                    checked={workgroupId === workgroup.workgroupId}
                    checkColor={workgroupId === workgroup.workgroupId}
                    onClick={() => {
                      setWorkgroupId(workgroup.workgroupId);
                    }}
                  />
                ))}
              </Box>
              <Box classes="fav-checkbox--bottom">
                <Button
                  label={t("admin.common.button.cancel")}
                  type="secondary"
                  btnStyle="fill"
                  onClick={() => {
                    setWorkgroupId(filterData.workgroupId + "");
                    setButtonClick(buttonClick + 1);
                  }}
                />
                <Button
                  label={t("admin.common.button.apply")}
                  classes="mg ml-10"
                  btnStyle="fill"
                  onClick={() => {
                    setFilterData({
                      ...filterData,
                      workgroupId: workgroupId,
                    });
                    setButtonClick(buttonClick + 1);
                  }}
                />
              </Box>
            </Box>
          </Dropdown>
        )}
      {filterData.workgroupIds !== undefined &&
        workgroupList &&
        loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE" && (
          <WorkgroupCheckboxDropdown
            workgroups={workgroupList}
            buttonClick={buttonClick}
            meetingFilter={filterData as any}
            changeFilterByKey={(_, workgroupIds) =>
              setFilterData({ ...filterData, workgroupIds: workgroupIds })
            }
            tab={page === "workgroupHistory" ? 1 : 0}
            page={page}
            setButtonClick={setButtonClick}
          />
        )}
      {filterData.dateFilter !== undefined && (
        <DateDropdown
          initValue={initFilterData.dateFilter ?? "1month"}
          filter={filterData}
          buttonClick={buttonClick}
          dateFilter={filterData.dateFilter}
          setButtonClick={setButtonClick}
          changeFilterByKey={(key: string, value: any) => {
            if (typeof value !== "object") {
              setFilterData({
                ...filterData,
                dateFilter: value,
                date: {
                  start: utilsCommon.getStartPeriod(value),
                  end: dayjs().endOf("day").valueOf(),
                },
              });
            } else {
              setFilterData({
                ...filterData,
                dateFilter: "custom",
                date: {
                  start: dayjs(value.start).valueOf(),
                  end: dayjs(value.end).valueOf(),
                },
              });
            }
          }}
        />
      )}
    </Box>
  );
};
export default AdminFilter;
